import gql from 'graphql-tag'

export const updateCartItem = gql`
  mutation updateCartItems(
    $cartId: String!
    $cartItems: [CartItemUpdateInput]!
  ) {
  updateCartItems(
    input: {
      cart_id: $cartId, 
      cart_items: $cartItems
    }
    ) {
      cart {
        email
      }
    }
  }
`
